import Icon from "common/components/base/icon";
import { FC, ReactNode } from "react";
import "./Page.scss";
import Loader from "common/components/base/loader";
import Button from "common/components/base/button";

type PageProps = {
  title?: string | null;
  isDataLoading?: boolean;
  rightSideContent?: ReactNode;
  className?: string;
  showIcon?: boolean;
  isError?: boolean;
  onRetry?: () => void;
  icon?: ReactNode;
  onIconSelect?: () => void | undefined;
  children: ReactNode;
};
// Simplify this component by removing unwanted return
const Page: FC<PageProps> = ({
  title,
  rightSideContent,
  className = "",
  showIcon = false,
  isError = false,
  isDataLoading = false,
  icon,
  onIconSelect,
  onRetry,
  children
}) => {
  return (
    <>
      <div className="app-page__title">
        {showIcon && (
          <Icon
            src={icon}
            className="app-page__title-icon"
            onClick={() => onIconSelect?.()}
          />
        )}
        {title && <h1>{title}</h1>}
        {rightSideContent}
      </div>
      <div className={`app-page__content ${className}`}>
        {isDataLoading ? (
          <div className="app-page__content-loading">
            <Loader show fullscreen={false} />
          </div>
        ) : isError ? (
          <div className="app-page__content-error">
            <p>
              An unexpected error occurred while loading data. Please try again
              later.
            </p>
            <Button variant="primary-alt" onClick={() => onRetry?.()}>
              Reload
            </Button>
          </div>
        ) : (
          children
        )}
      </div>
    </>
  );
};

export default Page;
